// **********************************************************
// Hero slider
// **********************************************************

const cardSwiperElements = document.querySelectorAll('[data-slider="card-slider"]');
const cardSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 12,
  speed: 600,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    586: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    769: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};

cardSwiperElements.forEach((el) => {
  const mainSliderParent = el.closest('.sc-card-list');
  const arrowRight = mainSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = mainSliderParent.querySelector('.swiper-button-prev');

  cardSliderOptions.navigation.nextEl = arrowRight;
  cardSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, cardSliderOptions);
});

const setPdfAnchorHrefs = () => {
  const linkUrl = document.querySelectorAll('.catalogue');
  linkUrl.forEach((item) => {
    const linkOfPdf = item.querySelector('.button-download-pdf')?.href;
    if (linkOfPdf) {
      item.querySelectorAll('a.button-open-pdf').forEach((inner) => {
        inner.href = linkOfPdf;
      });
    }
  });
};

window.addEventListener('load', () => {
  if (document.querySelector('.button-open-pdf')) {
    setPdfAnchorHrefs();
  }
});
